import { defineComponent as g, useCssModule as C, computed as c, createElementBlock as t, openBlock as a, unref as e, normalizeClass as s, createElementVNode as m, createBlock as y, createCommentVNode as n, renderSlot as u, createTextVNode as v, toDisplayString as B, withCtx as k } from "vue";
import f from "../../utils/mapClasses.mjs";
import $ from "../formError/CdrFormError.vue.mjs";
import q from "../../utils/uid.mjs";
const S = ["disabled", "aria-invalid", "aria-errormessage", "aria-describedby"], h = {
  key: 0,
  "aria-label": "required"
}, E = "cdr-form-group", x = /* @__PURE__ */ g({
  name: "CdrFormGroup",
  __name: "CdrFormGroup",
  props: {
    /**
     * Custom ID that is mapped to the form error. If this value is not set, it will be randomly generated.
     * @demoIgnore true
     */
    id: String,
    /**
     * Sets the label/legend for the form group. Applies default text styles to this label.
     * To override that default text style or apply other customization, use the `label` slot.
     * @demoIgnore true
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Sets the form group to an error state, displays the `error` slot if one is present.
     */
    error: {
      type: [Boolean, String],
      default: !1
    },
    /** Adds required label to the form group. */
    required: Boolean,
    /** Adds optional label to the form group. */
    optional: Boolean,
    /** Renders form group in a disabled state. */
    disabled: {
      type: Boolean,
      default: void 0
    }
  },
  setup(r) {
    const o = r, l = o.id ? o.id : q(), d = C(), b = c(() => o.error ? "cdr-form-group--error" : ""), p = c(() => o.disabled ? "cdr-form-group--disabled" : "");
    return (i, F) => (a(), t("fieldset", {
      class: s(e(f)(e(d), E, p.value)),
      disabled: r.disabled,
      "aria-invalid": !!r.error,
      "aria-errormessage": r.error ? `${e(l)}-error` : void 0,
      "aria-describedby": r.error ? `${e(l)}-error` : void 0
    }, [m("legend", null, [u(i.$slots, "label", {}, () => [v(B(r.label), 1)]), r.required ? (a(), t("span", h, " *")) : n("", !0), r.optional && !r.required ? (a(), t("span", {
      key: 1,
      class: s(e(d)["cdr-form-group__optional"])
    }, " (optional)", 2)) : n("", !0)]), m("div", {
      class: s(e(f)(e(d), "cdr-form-group__wrapper", b.value))
    }, [u(i.$slots, "default")], 2), r.error ? (a(), y($, {
      key: 0,
      error: r.error,
      id: `${e(l)}-error`,
      "aria-live": "polite"
    }, {
      error: k(() => [u(i.$slots, "error")]),
      _: 3
    }, 8, ["error", "id"])) : n("", !0)], 10, S));
  }
});
export {
  x as default
};
